export default __webpack_public_path__ + "images/0x50bc6e1dff8039a4b967c1bf507ba5ea13fa18b6.png";